import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {TopAppBar as RmwcTopAppBar} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const StyledRmwcTopAppBar = styled(RmwcTopAppBar)``

const TopAppBar = ({children, ...otherProps}) => <StyledRmwcTopAppBar {...otherProps}>{children}</StyledRmwcTopAppBar>

TopAppBar.propTypes = {
  children: PropTypes.any
}

export {TopAppBar}
